module.exports = __webpack_public_path__ + "media/images/4-2b77731f14b07ba2396098de3f3be06a.svg";